/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Observable } from 'rxjs';
import { AbstractObject } from '@src/app/model/abstract-object';
import { Field } from '@src/app/shared/field/Field';
import { FormPillComponent, PillField, PillState } from '@src/app/shared/form/form-pill/form-pill.component';

const isCurrentStates: PillState[] = [
    { id: 'active', name: $localize`Active`, style: 'infill', color: 'green' },
    { id: 'archived', name: $localize`Archived`, style: 'infill', color: 'red' },
];

export interface IsCurrentPillOptions {
    toggle: (o: AbstractObject) => Observable<AbstractObject | null>;
    afterToggle: (o: AbstractObject) => void;
    formColumn: number;
}

/** A record that can be archived and brought back - a click confirms and flips isCurrent. */
export function makeIsCurrentPillField(o: IsCurrentPillOptions): PillField {
    return FormPillComponent.make($localize`Active`, 'isCurrent', {
        states: isCurrentStates,
        condensed: false,
        formClick: o.toggle,
        afterFormChange: o.afterToggle,
        clickTip: (item) => item['isCurrent'] ? $localize`Click to archive` : $localize`Click to reactivate`,
    }).override({
        calculateValue: (item: AbstractObject) => item['isCurrent'] ? 'active' : 'archived',
        formColumn: o.formColumn,
        visible: Field.formOnly,
    });
}
